module.exports = __webpack_public_path__ + "img/multiplier_0_zh.a5022e15.png";